var map = {
	"./": "8905",
	"./icon": "8536",
	"./icon.jsx": "8536",
	"./index": "8905",
	"./index.jsx": "8905",
	"./link": "2db6",
	"./link.jsx": "2db6",
	"./number": "52e4",
	"./number.jsx": "52e4",
	"./switch": "173a",
	"./switch.jsx": "173a",
	"./tag": "8eef",
	"./tag.jsx": "8eef",
	"./text": "79e2",
	"./text.jsx": "79e2",
	"./time": "f9c6",
	"./time.jsx": "f9c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7070";